import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Body,
  Button,
  Grid,
  Heading
} from '@walmart-web/livingdesign-components';

import styles from './styles.module.css';
import { useHistory, useLocation } from 'react-router-dom';

type Props = {
  onClick?: () => void;
};

type LocationState = {
  state?: {
    from?: string;
  };
};

const NotificationsError: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation('profile');
  const location = useLocation() as LocationState;
  const history = useHistory();

  const handleClick = () => {
    if (onClick) return onClick();
    history.push(
      (typeof location.state === 'object' && location.state.from) || '/home'
    );
  };

  return (
    <Grid UNSAFE_className={styles.errorContainer}>
      <img src="/assets/images/notifications/cat_circle.png" />
      <Grid UNSAFE_className={styles.msgContainer}>
        <Heading>{t('notifications.error.title')}</Heading>
        <Body UNSAFE_className={styles.msgBody} size="medium">
          {t('notifications.error.message')}
        </Body>
      </Grid>
      <Button variant="primary" size="medium" onClick={handleClick}>
        {t('notifications.error.btnText')}
      </Button>
    </Grid>
  );
};

export default NotificationsError;
